export const reportCategories = [
  { id: 'flag_profile_inaccuracy', label: 'Flag profile inaccuracy' },
  { id: 'data_protection', label: 'Data protection' },
  { id: 'report_profile_content', label: 'Report profile content' },
  { id: 'report_error_or_bug', label: 'Report an error or bug' },
  { id: 'something_else', label: 'Something else' },
] as const

export type ReportCategory = (typeof reportCategories)[number]['id']

export type ProfileReport = {
  first_name: string
  last_name: string
  email_address: string
  phone_number: string
  message: string
  category: ReportCategory
  profile_url: string
} & (
  | { lawyer: string }
  | { barrister: string }
  | { organisation: string }
  | { chamber: string }
)
